import React from 'react';
import {Form, Input, Button} from 'antd';
import './style.scss'
import {Link} from "react-router-dom";

const ProSignIn = () => {
    const onFinish = (values) => {
        console.log('Received values of form: ', values);
        window.location.href='/business/shopping'
    };

    return (
        <div style={{marginTop: '5vw'}}>
            <div className="Title">
                Vieunite Pro Business Sign In
            </div>
            <Form
                initialValues={{remember: true}}
                onFinish={onFinish}
                colon={false}
            >
                <Form.Item
                    label={<span className="email-label">Email</span>}
                    name="email"
                    rules={[{message: 'Please input your email!'}]}
                    labelCol={{span: 8}}
                    wrapperCol={{span: 5}}
                >
                    <Input className={'input-Email-form'}/>
                </Form.Item>
                <Form.Item
                    label={<span className="password-label">Password</span>}
                    name="Password"
                    rules={[{message: 'Please input your password!'}]}
                    labelCol={{span: 8}}
                    wrapperCol={{span: 5}}
                >
                    <Input.Password className={'input-Password-form'}/>
                </Form.Item>
                <div className="forgot-password-link">
                    <Link to="/business/ProForgotPassword">Forgot your password?</Link>
                </div>
                <div className="center-button">
                    <Button type="primary" htmlType="submit" className="custom-Login-button">
                        Login
                    </Button>
                </div>
                <div className="center-button">
                    <Button type="primary"
                            className="custom-Create-button"
                            onClick={_ => window.location.href = '/business/prosignup'}
                    >
                        Create an account
                    </Button>
                </div>
            </Form>


        </div>
    );
};

export default ProSignIn;
